const features = [
  {
    icon: 'ri-radar-line',
    title: '实时热点追踪',
    desc: '全天候监控全网娱乐动态，热点大瓜第一时间捕捉。从社交平台到主流媒体，覆盖50+资讯源，确保你不遗漏任何娱乐圈热点事件。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '独家爆料精选',
    desc: '聚合多方信源交叉验证，筛选最具话题性的娱乐大瓜。我们坚持内容质量优先，为你过滤噪音，呈现高价值的吃瓜资讯。',
  },
  {
    icon: 'ri-lightbulb-flash-line',
    title: '深度吃瓜解读',
    desc: '不止于爆料，更关注热点背后的来龙去脉。用通俗易懂的方式梳理事件脉络，带你从吃瓜群众升级为懂瓜达人。',
  },
];

export default function FeaturesSection() {
  return (
    <section
      id="features"
      className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100"
      style={{ scrollMarginTop: '80px' }}
    >
      <div className="w-full max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            吃瓜利器
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">
            三大核心能力，让你吃瓜快人一步
          </p>
        </div>

        {/* Feature Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {features.map((item, i) => (
            <div
              key={i}
              className="group flex flex-col items-center text-center p-6 md:p-8 rounded-lg bg-background-50 border border-background-200/70 transition-colors duration-200 hover:border-primary-200"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-100 mb-4 transition-colors duration-200 group-hover:bg-primary-200">
                <i className={`${item.icon} text-primary-600 text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}